"use client"
import { iconsMap } from "@/public/icons/iconsMap"
import { sendBlockEvent } from "@/utils/gtm"
import { Typography } from "@mui/material"
import ButtonWithArrow from "ui/common/bit/ButtonWithArrow"
import CommonTitle from "ui/common/bit/CommonTitle"
import RichTextWrapper from "ui/common/bit/RichTextWrapper"
import { colors } from "ui/theme/colors"
import { transformProperties } from "utils/simplifyData"
import ExtendedPlusMinusCollapse from "../common/bit/ExtendedPlusMinusCollapse"
import BlockWrapper from "../common/BlockWrapper"

type Props = {
  data: any
  locale: string
}

const ExtendedPlusMinusCollapseList = ({
  data,
  id,
}: Props & { id?: string }) => {
  const title = data?.title?.value
  const subtitle = data?.subtitle?.value
  const smallTitle = data?.smallTitle?.value
  const items = data?.itemsList?.blocks
  const button = data?.button?.links[0]

  const handleButtonClick = (buttonName: string) => {
    sendBlockEvent({
      blockId: id || "1",
      title: title,
      componentName: "מידע נוסף",
      productName: data?.productName || data?.formDefaultInsuranceType,
      buttonName: buttonName,
    })
  }
  return (
    <>
      <BlockWrapper id={id} style={{ gap: "20px", alignItems: "center" }}>
        <CommonTitle title={title} subtitle={subtitle} text={smallTitle} />
        {items.map((item: any, index: number) => {
          const { title, subtitle, text } = transformProperties(item.properties)
          const PlusIcon = iconsMap["plus-element"]
          const MinusIcon = iconsMap["minus-element"]
          return (
            <ExtendedPlusMinusCollapse
              key={`ExtendedPlusMinusCollapseList-AccordionItem-${index}`}
              openIcon={<PlusIcon />}
              closeIcon={<MinusIcon />}
              summaryContent={
                <AccordionSummaryContent title={title} subtitle={subtitle} />
              }
              detailsContent={
                <AccordionDetailsContent subtitle={subtitle} text={text} />
              }
              onClick={() => handleButtonClick(title?.value)}
            />
          )
        })}
        {button && (
          <ButtonWithArrow
            href={button?.url}
            onClick={() => handleButtonClick(button?.name)}
          >
            {button?.name}
          </ButtonWithArrow>
        )}
      </BlockWrapper>
    </>
  )
}

interface AccordionSummaryContentProps {
  title: { value: string }
  subtitle: { value: string }
}

const AccordionSummaryContent: React.FC<AccordionSummaryContentProps> = ({
  title,
  subtitle,
}) => {
  return (
    <>
      <Typography variant="body2" component="h3" color={colors.red}>
        {title.value}
      </Typography>
      <Typography variant="body2">{subtitle.value}</Typography>
    </>
  )
}

interface AccordionDetailsContentProps {
  subtitle: { value: string }
  text: { richText: string }
}

const AccordionDetailsContent: React.FC<AccordionDetailsContentProps> = ({
  text,
}) => {
  return <RichTextWrapper richText={text.richText} />
}

export default ExtendedPlusMinusCollapseList
